export default {
  en: require('./en.json'),
  de: require('./de.json'),
  eo: require('./eo.json'),
  fr: require('./fr.json'),
  cs: require('./cs.json'),
  ar: require('./ar.json')
}
